import { Lock, Users, Filter, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Leads() {
  const funnel = [
    { label: "Reached", value: "63.8K", w: "100%" },
    { label: "Clicked", value: "1.2K", w: "62%" },
    { label: "Form views", value: "892", w: "40%" },
    { label: "Enquiries", value: "—", w: "18%" },
  ];
  return (
    <div className="space-y-8">
      <header className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Leads</h1>
          <p className="mt-1 text-muted-foreground">Your enquiry and admissions pipeline, connected to marketing.</p>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-muted px-3 py-1.5 text-xs font-semibold text-muted-foreground">
          Needs setup
        </span>
      </header>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-3xl border border-border/60 bg-card p-8 shadow-sm">
          <p className="text-sm font-semibold">Admissions pipeline</p>
          <p className="mb-6 text-xs text-muted-foreground">Preview — 0 enquiries collected</p>
          <div className="space-y-3 opacity-70">
            {funnel.map((f) => (
              <div key={f.label}>
                <div className="mb-1 flex justify-between text-xs"><span className="font-medium">{f.label}</span><span className="text-muted-foreground">{f.value}</span></div>
                <div className="h-3 overflow-hidden rounded-full bg-muted"><div className="h-full rounded-full nuera-gradient" style={{ width: f.w }} /></div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative overflow-hidden rounded-3xl border border-border/60 bg-card p-8 text-center shadow-sm">
          <div className="mx-auto max-w-sm py-6">
            <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl nuera-gradient text-white shadow-sm">
              <Users className="h-7 w-7" />
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight">Lead intelligence is coming in Phase 2</h2>
            <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
              Connect your CRM and lead forms and Nuera will tie every enquiry back to the campaign, channel and content that created it.
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-sm text-muted-foreground">
              <span className="inline-flex items-center gap-1.5"><Filter className="h-4 w-4" /> Source attribution</span>
              <span className="inline-flex items-center gap-1.5"><Sparkles className="h-4 w-4" /> Revenue insights</span>
            </div>
            <Button disabled className="mt-6 rounded-full" data-testid="leads-locked">
              <Lock className="mr-1.5 h-4 w-4" /> Available in Phase 2
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
